import useWidgetFetch from "./useWidgetFetch";

export default useWidgetFetch;
